import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../contexts/auth";
import Toggle from "./toggle";
import { DailyShift } from "./daily_shift";
import WeeklyShift from "./weekly_shift";
import ComboboxAutocomplete from "./combobox_autocomplete";
import { listOrganizationalUnits } from "../services/api_org_unit";


const CreateShift = ({onShiftAdded, onWeeklyShiftAdded}) => {
  const { token } = useContext(AuthContext);
  const searchParams = new URLSearchParams(window.location.search);
  const availableTypes = ["giornaliero", "settimanale"];
  const [selectedUnitOption, setSelectedUnitOption] = useState('nessuna');
  const [unitConfirmed, setUnitConfirmed] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [units, setUnits] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showUnitSelection, setShowUnitSelection] = useState(true);
  const [selectedUnitToPair, setSelectedUnitToPair] = useState(null);
  
  const [shiftType, setShiftType] = useState(
    availableTypes.includes(searchParams.get('type'))
    ? searchParams.get('type').toUpperCase()
    : "null" 
  );

  useEffect(() => {
    async function fetchData() {
      try {
        const unitsData = await listOrganizationalUnits(token, true);
        setUnits(unitsData.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching units:', error);
        setError(true);
        setIsLoading(false);
      }
    }
    fetchData();
  }, [token]);

  const handleSelectUnit = (selected) => {
    const unit = selected === 'all' || !selected ? null : selected;
    setSelectedUnit(unit);
  };

  const handleToggleChange = (selectedOption) => {
    setShiftType(selectedOption);
    setShowUnitSelection(true);
  };

  const handleUnitOptionChange = (event) => {
    const value = event.target.value;
    setSelectedUnitOption(value);
  
    if (value === 'nessuna') {
      setSelectedUnit(null);
    }
  };

  const handleConfirmUnit = () => {
    setSelectedUnitToPair(selectedUnitOption === 'nessuna' ? null : selectedUnit);
    setShowUnitSelection(false);
  };

  const handleResetUnit = () => {
    setShowUnitSelection(true);
    setSelectedUnitOption('nessuna');
    setSelectedUnit(null);
  };

  const unitToPass = selectedUnitOption === 'unità' ? selectedUnit : null;

  return (
    <div>
      <div className="border border-t-2 border-indigo-600 mt-2"></div>
      <div className="flex justify-center p-4">
        <p className="text-sm">
          Effettua la creazione del Turno Giornaliero e assegnalo nella
          visualizzazione calendario dei dipendenti con contratto a turno. <br />
          Nel Turno Settimanale potrai impostare l'orario su ogni giorno della
          settimana. Puoi utilizzare anche i turni Giornalieri già creati.
        </p>
      </div>

      <div className="flex justify-center pb-4">
        <Toggle
          color='indigo'
          gradeBgColor="600"
          optionLeft={availableTypes[0].toUpperCase()}
          optionRight={availableTypes[1].toUpperCase()}
          selectedOption={shiftType}
          onChange={handleToggleChange}
        />
      </div>

      {shiftType === "GIORNALIERO" && (
        <DailyShift onShiftAdded={onShiftAdded}  />
      )}

      {shiftType === "SETTIMANALE" && (
        <> 
          {showUnitSelection && (
            <div className="container border border-solid-2 border-gray-200 shadow-md rounded-md my-5 bg-white justify-center p-4">         
              <div className="flex items-center mb-4">
                <input
                  type="checkbox"
                  id="unità"
                  name="unitOption"
                  value="unità"
                  checked={selectedUnitOption === 'unità'}
                  onChange={handleUnitOptionChange}
                  className="rounded text-indigo-600 focus:ring-indigo-600"
                />
                <label htmlFor="unità" className="ml-2">
                  <h2 className="text-sm font-medium text-gray-700 uppercase text-left pb-1">
                    Seleziona unità organizzativa da associare al turno
                  </h2>
                  <h3 className="text-xs font-normal text-gray-700">
                    Seleziona l'Unità organizzativa alla quale associare il turno settimanale oppure seleziona 'Nessuna Unità' per rendere il turno disponibile per i dipendenti che non hanno unità organizzativa
                  </h3>
                </label>
              </div>

              <div className="w-1/2">
                {selectedUnitOption === 'unità' && (
                  <div className="items-center mb-4 w-full ml-6">
                    <ComboboxAutocomplete
                      options={units}
                      bgActiveColor="bg-indigo-100"
                      textActiveColor="text-gray-900"
                      placeholder="Seleziona l'Unità Organizzativa"
                      onChange={handleSelectUnit}
                      value={selectedUnit}
                      positionOptions="relative"
                    />
                  </div>
                )}
              </div>
              
              <div className="flex items-center mb-4">
                <input
                  type="checkbox"
                  id="nessuna"
                  name="unitOption"
                  value="nessuna"
                  checked={selectedUnitOption === 'nessuna'}
                  onChange={handleUnitOptionChange}
                  className="rounded text-indigo-600 focus:ring-indigo-600"
                />
                <label htmlFor="nessuna" className="ml-2">
                  <h2 className="text-sm font-medium text-gray-700 uppercase text-left">
                    Nessuna Unità
                  </h2>
                </label>
              </div>
              <div className="text-center">
                <button
                  className="px-4 py-2 rounded-md bg-indigo-600 hover:bg-indigo-500 text-white shadow-md uppercase text-sm font-semibold"
                  onClick={handleConfirmUnit}
                >
                  Conferma Selezione
                </button>
              </div>
            </div>
          )}
          {!showUnitSelection && (
            <WeeklyShift
              onWeeklyShiftAdded={onWeeklyShiftAdded}
              selectedUnitToPair={unitToPass}
              onResetUnit={handleResetUnit}
            />
          )}
        </>
      )}
      
    </div>
  );
};

export default CreateShift;
